import React, { useState } from 'react';
import { Button, Form, Input, message, Switch } from 'antd';

import { FormsService } from '../../../API/FormsService';

import styles from '../Form.module.css';

export default function FormEdit() {
    const [form] = Form.useForm();

    const [editableForm, setEditableForm] = useState({ allow: true });
    const [isFildsFill, setIsFildsFill] = useState(false);
    const [loading, setLoading] = useState(false);

    const onValuesChange = (changedValues, allValues) => {
        setEditableForm(prev => ({ ...prev, ...allValues }));

        if (allValues?.id?.length > 0 && allValues?.name?.length > 0) {
            setIsFildsFill(true);
        } else {
            setIsFildsFill(false);
        }
    };

    const onAllowChange = checked => {
        setEditableForm(prev => ({ ...prev, allow: checked }));
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);

        const data = await FormsService.editForm(editableForm, message);

        if (data) {
            setLoading(false);
            form.resetFields();
            setEditableForm({ allow: true });
            setIsFildsFill(false);
        } else {
            setLoading(false);
        }
    };

    return (
        <Form
            name='basic'
            size='large'
            form={form}
            labelCol={{
                span: 6,
            }}
            wrapperCol={{
                span: 16,
            }}
            autoComplete='off'
            onValuesChange={onValuesChange}
        >
            <Form.Item
                label='ID'
                name='id'
                rules={[
                    {
                        required: true,
                        message: 'Необходимо указать ID формы',
                    },
                ]}
            >
                <Input value={editableForm.id} />
            </Form.Item>
            <Form.Item
                label='Новое имя формы'
                name='name'
                rules={[
                    {
                        required: true,
                        message: 'Необходимо указать новое имя формы',
                    },
                ]}
            >
                <Input value={editableForm.name} />
            </Form.Item>
            <Form.Item label='Принимать результаты?' valuePropName='checked' name='allow' initialValue={true}>
                <Switch defaultChecked onChange={onAllowChange} />
            </Form.Item>
            <Form.Item
                wrapperCol={{
                    offset: 6,
                    span: 16,
                }}
            >
                <div className={styles.buttonContainer}>
                    <Button className={styles.formButton} type='primary' danger onClick={handleSubmit} disabled={!isFildsFill} loading={loading}>
                        Изменить форму
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
}
